import { OrderForm } from '~domains/commerce/orders/widgets/order-form';

export const CreateOrderPage = () => {
  return <OrderForm />;
};
